import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppData } from '@shared/models/appdata.model';
import { UpdateEquipmentRequest, IdentifierType, OrderCaptureItem } from '../models/sps-order-item.model';
import { Seller } from '@core/models/dealer.model';
import { PlaceItemsResponse } from '../models/place-items-response.model';
import { ProductOrderRequest } from '@app/shared/models/order.model';

@Injectable({
  providedIn: 'root',
})
export class OrderService {
  private http = inject(HttpClient);
  private appData = inject(AppData);

  apiUrl = this.appData.apiUrl + '/api/v1';

  // TODO: change to order capture id, instead of order service id.
  getOrderCaptureItem(orderServiceId: number): Observable<OrderCaptureItem> {
    const url = `${this.apiUrl}/order/ios/${orderServiceId}`;
    return this.http.get<OrderCaptureItem>(url);
  }

  getSellerInfo(orderCaptureId: number): Observable<Seller> {
    const url = `${this.apiUrl}/order/${orderCaptureId}/seller-info`;
    return this.http.get<Seller>(url);
  }

  cancelOrder(orderServiceId: number, reason: string) {
    const url = `${this.apiUrl}/order/ios/${orderServiceId}/cancel?reason=${reason}`;
    return this.http.post(url, null);
  }

  updateEquipment(request: UpdateEquipmentRequest) {
    const url = `${this.apiUrl}/order/update-equipment`;
    return this.http.put(url, request);
  }

  getMissingProductIdentifiersCount(identifierType: IdentifierType): Observable<number> {
    const url = `${this.apiUrl}/order/missing-product-identifier-count?identifierType=${identifierType}`;
    return this.http.post<number>(url, null);
  }

  isIdentifierUsed(identifierType: IdentifierType, value: string): Observable<boolean> {
    const url = `${this.apiUrl}/order/is-identifier-used?identifierType=${identifierType}&identifierValue=${value}`;
    return this.http.get<boolean>(url);
  }

  createOrder(request: ProductOrderRequest): Observable<PlaceItemsResponse> {
    const url = `${this.apiUrl}/order`;
    return this.http.post<PlaceItemsResponse>(url, request);
  }
}
